interface Props {
  className?: string;
}

interface IMapMarkersProps {
  iconName: string;
}

function Beach({ className }: Props) {
  return (
    <svg
      width={50}
      height={50}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25z"
        fill="#fff"
      />
      <path
        d="M25 45c11.046 0 20-8.954 20-20S36.046 5 25 5 5 13.954 5 25s8.954 20 20 20z"
        fill="currentColor"
      />
      <path
        d="M14.55 31.597h.55c.895 0 1.574-.316 1.928-.672.306-.308.676-.529 1.092-.529h.56c.417 0 .787.221 1.093.53.353.355 1.032.671 1.927.671s1.574-.316 1.928-.672c.306-.308.676-.529 1.092-.529h.56c.417 0 .787.221 1.093.53.353.355 1.032.671 1.927.671s1.574-.316 1.928-.672c.306-.308.676-.529 1.092-.529h.56c.417 0 .787.221 1.093.53.353.355 1.032.671 1.927.671h.55c.304 0 .55.27.55.601V33.4c0 .332-.246.601-.55.601h-.55c-1.328 0-2.5-.458-3.3-1.195-.8.738-1.973 1.195-3.3 1.195-1.328 0-2.5-.458-3.3-1.195-.8.738-1.973 1.195-3.3 1.195-1.328 0-2.5-.458-3.3-1.195-.8.738-1.972 1.195-3.3 1.195h-.55c-.304 0-.55-.269-.55-.6v-1.202c0-.332.246-.6.55-.6zM29.482 25.422c-.122.12-.525.345-1.182.345-.657 0-1.06-.226-1.182-.345-.55-.54-1.186-.826-1.838-.826h-.56c-.652 0-1.287.286-1.838.826-.122.12-.525.345-1.182.345-.657 0-1.06-.226-1.182-.345-.511-.502-1.096-.773-1.698-.81l3.23-2.377c.434-.32.49-.98.117-1.378l-.129-.137-.423-.45-.416-.296a3.24 3.24 0 00-1.878-.605h-1.09c-.586-.066-1.172-.04-1.477-.318-.308-.28-.272-.796-.279-1.227-.03-1.789 1.374-1.823 1.452-1.824h.72c.741 0 1.474.171 2.141.515 1.06.546 2.646 1.387 3.211 1.817l2.75 2.092c.358.27.666.602.92.986l2.358 3.588a3.177 3.177 0 00-.545.424zM14.55 26.938h.55c.895 0 1.574-.308 1.928-.655.306-.3.676-.516 1.092-.516h.56c.417 0 .787.216 1.093.516.353.347 1.032.655 1.927.655s1.574-.308 1.928-.655c.306-.3.676-.516 1.092-.516h.56c.417 0 .787.216 1.093.516.353.347 1.032.655 1.927.655s1.574-.308 1.928-.655c.306-.3.676-.516 1.092-.516h.56c.417 0 .787.216 1.093.516.353.347 1.032.655 1.927.655h.55c.304 0 .55.262.55.586v1.171c0 .324-.246.586-.55.586h-.55c-1.328 0-2.5-.447-3.3-1.166-.8.72-1.973 1.166-3.3 1.166-1.328 0-2.5-.447-3.3-1.166-.8.72-1.973 1.166-3.3 1.166-1.328 0-2.5-.447-3.3-1.166-.8.72-1.972 1.166-3.3 1.166h-.55c-.304 0-.55-.262-.55-.586v-1.171c0-.324.246-.586.55-.586zm17.6-3.514c-1.519 0-2.75-1.31-2.75-2.927s1.231-2.929 2.75-2.929 2.75 1.311 2.75 2.928-1.231 2.928-2.75 2.928z"
        fill="#fff"
      />
    </svg>
  );
}

function Camera({ className }: Props) {
  return (
    <svg
      width={50}
      height={50}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx={25} cy={25} r={25} fill="#fff" />
      <circle cx={25} cy={25} r={20} fill="currentColor" />
      <path
        d="M35 17.609h-3.465l-1.704-2.222a.963.963 0 00-.36-.284A1.122 1.122 0 0029 15h-8c-.165 0-.326.035-.471.103a.964.964 0 00-.36.284l-1.705 2.222H15c-.796 0-1.559.274-2.121.764-.563.489-.879 1.152-.879 1.844v12.174c0 .692.316 1.356.879 1.845.562.49 1.325.764 2.121.764h20c.796 0 1.559-.275 2.121-.764.563-.49.879-1.153.879-1.845V20.217c0-.691-.316-1.355-.879-1.844-.562-.49-1.325-.764-2.121-.764zm1 14.782c0 .23-.105.452-.293.615a1.08 1.08 0 01-.707.255H15a1.08 1.08 0 01-.707-.255.817.817 0 01-.293-.615V20.217c0-.23.105-.451.293-.614a1.08 1.08 0 01.707-.255h4c.165 0 .327-.035.472-.103a.965.965 0 00.36-.284l1.703-2.222h6.929l1.704 2.222c.09.119.215.217.36.284.145.068.307.103.472.103h4c.265 0 .52.091.707.255a.817.817 0 01.293.614v12.174zM25 21.087c-1.088 0-2.151.28-3.056.806-.904.526-1.61 1.272-2.025 2.146a4.206 4.206 0 00-.313 2.764c.212.927.736 1.78 1.505 2.448.77.67 1.75 1.125 2.816 1.31a6.27 6.27 0 003.178-.273c1.005-.362 1.864-.975 2.468-1.761a4.353 4.353 0 00.927-2.657c-.002-1.268-.582-2.484-1.613-3.38-1.03-.897-2.429-1.402-3.887-1.403zm0 7.826a3.884 3.884 0 01-1.945-.513 3.179 3.179 0 01-1.289-1.366 2.677 2.677 0 01-.199-1.758c.135-.59.469-1.133.958-1.558a3.689 3.689 0 011.792-.833 3.989 3.989 0 012.022.173c.64.23 1.187.62 1.571 1.12.385.501.59 1.09.59 1.692 0 .807-.369 1.58-1.025 2.152-.657.57-1.547.891-2.475.891z"
        fill="#fff"
      />
    </svg>
  );
}

function City({ className }: Props) {
  return (
    <svg
      width={50}
      height={50}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx={25} cy={25} r={25} fill="#fff" />
      <circle cx={25} cy={25} r={20} fill="currentColor" />
      <path
        d="M14 18.224v19.802h21.5V23.882h-7.355v-9.053L24.75 12l-3.395 2.829v3.395H14z"
        fill="#fff"
      />
      <path
        d="M23.803 21.237h1.894v1.329h-1.894v-1.33zm1.894 7.552h-1.894V27.46h1.894v1.33zm0 6.224h-1.894v-1.329h1.894v1.33zm-8.684-13.776h1.895v1.329h-1.895v-1.33zm0 7.552V27.46h1.895v1.33h-1.895zm1.895 6.224h-1.895v-1.329h1.895v1.33zm13.579 0h-1.895v-1.329h1.895v1.33zm-1.895-7.553h1.895v1.33h-1.895v-1.33zm-6.79-10.552v-1.33h1.895v1.33h-1.894z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={1.5}
      />
    </svg>
  );
}

const iconsMap = [
  {
    names: ['camera', 'check', 'pin', 'eye-on'],
    icon: `attraction`,
  },
  {
    names: ['beach'],
    icon: `natural_feature`,
  },
  {
    names: ['city'],
    icon: `locality`,
  }
]

export const MapMarkers = ({ iconName }: IMapMarkersProps) => {
  const currentIcon = iconsMap.filter(icon => icon.names.includes(iconName))[0] || iconsMap[0];

  return currentIcon.icon;
}
